import React from "react";
import { Ban } from "lucide-react";
import { useSingleFlight } from "../../utils/singleFlight";
import { confirmAndCancelTask, cancelErrorText } from "../../utils/taskCancel";

// TZ8-4: отмена задания с возвратом из раздела «Обсуждения» (штатный POST /tasks/{id}/cancel)
export const CancelWithRefundButton = ({ task, showToast, onDone, testId, className }) => {
  const { run, isBusy } = useSingleFlight();
  const handleClick = () => run(`cancel:${task.id}`, async () => {
    try {
      const result = await confirmAndCancelTask(task);
      if (!result) return;
      showToast(result.text, result.tone, 12000);
      if (onDone) onDone();
    } catch (error) {
      showToast(cancelErrorText(error), "error");
    }
  });
  return (
    <button
      data-testid={testId}
      onClick={handleClick}
      disabled={isBusy(`cancel:${task.id}`)}
      className={className || "reversia-btn reversia-btn-danger-soft reversia-btn-md justify-center"}
    >
      <Ban size={14} className="inline mr-1.5" />{task.is_b2b ? "Отменить задание" : "Отменить с возвратом"}
    </button>
  );
};
